import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const COORDS = [
  [39.9339, 9.7073],
  [39.8355, 9.5852],
  [40.1194, 9.2536],
];

const pinIcon = L.divIcon({
  className: "",
  html: `<div style="width:34px;height:34px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:#0F2B3A;border:2px solid #4BB3E8;box-shadow:0 8px 20px rgba(15,43,58,.35);display:flex;align-items:center;justify-content:center"><span style="transform:rotate(45deg);width:8px;height:8px;border-radius:50%;background:#4BB3E8"></span></div>`,
  iconSize: [34, 34],
  iconAnchor: [17, 34],
  popupAnchor: [0, -34],
});

export default function ExperiencesMap({ items, labels, onEnquire }) {
  return (
    <div data-testid="experiences-map" className="relative z-0 overflow-hidden rounded-[2rem] ring-1 ring-navy/10">
      <MapContainer center={[39.97, 9.45]} zoom={9} scrollWheelZoom={false} className="h-[420px] w-full sm:h-[480px]">
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {items.map((item, i) => (
          <Marker key={item.title} position={COORDS[i]} icon={pinIcon}>
            <Popup>
              <div className="min-w-[200px] font-body">
                <p className="font-display text-base font-semibold text-navy">{item.title}</p>
                <p className="mt-1 text-xs font-semibold text-mute">{item.location}</p>
                <p className="mt-2 text-sm font-extrabold text-navy">
                  {labels.from} {item.price} <span className="text-xs font-semibold text-mute">{labels.person}</span>
                </p>
                <button
                  data-testid={`map-popup-cta-${i}`}
                  onClick={() => onEnquire(item.title)}
                  className="mt-3 w-full rounded-full bg-navy px-4 py-2 text-xs font-bold text-white transition-colors hover:bg-med"
                >
                  {labels.cta}
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
